<template>
    <div class="channelItem diffItem" :class="{'diffItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallPossion.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url)">查看详情分析 ></em>
                <span v-else>{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.info.url)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataDiffDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataDiff.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <p v-if="data.schedule.wdl_predict_status == 1">胜平负 <span>命中</span></p>
                            <p v-if="data.schedule.tl_predict_status == 1">总进球 <span>命中</span></p>
                            <p v-if="data.schedule.conner_predict_status == 1">角球 <span>命中</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.is_buy == 1 && data.has_data == 1" class="haveData">
                <div class="diffTable wdl">
                    <div class="header">胜平负</div>
                    <div class="table">
                        <div class="thead">
                            <p class="name">选项</p>
                            <div class="main">
                                <p>出现概率</p>
                                <p>竞彩赔率</p>
                                <p>影响因素</p>
                                <p>差异值</p>
                            </div>
                            <p class="wdlres">模型倾向</p>
                        </div>
                        <div class="tbody">
                            <p class="name">
                                <span>胜</span>
                                <span>平</span>
                                <span>负</span>
                            </p>
                            <div class="main">
                                <p>
                                    <span>{{data.analy.win_chance}}%</span>
                                    <span>{{data.analy.draw_chance}}%</span>
                                    <span>{{data.analy.loss_chance}}%</span>
                                </p>
                                <p>
                                    <span>{{ data.analy.win_sp }}</span>
                                    <span>{{ data.analy.draw_sp }}</span>
                                    <span>{{ data.analy.loss_sp }}</span>
                                </p>
                                <p class="diffodds">
                                    <span>{{ data.analy.win_popular }}</span>
                                    <span>{{ data.analy.draw_popular }}</span>
                                    <span>{{ data.analy.loss_popular }}</span>
                                </p>
                                <p class="diffVal">
                                    <span>{{ data.analy.win_bet_diff }}%</span>
                                    <span>{{ data.analy.draw_bet_diff }}%</span>
                                    <span>{{ data.analy.loss_bet_diff }}%</span>
                                </p>
                            </div>
                            <p class="wdlres" v-html="dealWdlResultColor()"></p>
                        </div>
                    </div>
                </div>
                <div class="diffTable">
                    <div class="header">总进球（{{data.analy.tl_handicap}}）</div>
                    <div class="table">
                        <div class="thead">
                            <p class="name">选项</p>
                            <div class="main">
                                <p>出现概率</p>
                                <p>差异指数</p>
                                <p>模型倾向</p>
                            </div>
                        </div>
                        <div class="tbody">
                            <p class="name">
                                <span>大</span>
                                <span>小</span>
                            </p>
                            <div class="main">
                                <p>
                                    <span>{{data.analy.tl_rate_left}}%</span>
                                    <span>{{data.analy.tl_rate_right}}%</span>
                                </p>
                                <p class="diffodds">{{data.analy.tl_rate_diff}}</p>
                                <p class="diffres" :class="{'resultRed': data.analy.tl_predict_status == '1'}">
                                    {{dealDxData(data.analy.tl_predict)}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="diffTable">
                    <div class="header">角球（{{data.analy.conner_handicap}}）</div>
                    <div class="table">
                        <div class="thead">
                            <p class="name">选项</p>
                            <div class="main">
                                <p>出现概率</p>
                                <p>差异指数</p>
                                <p>模型倾向</p>
                            </div>
                        </div>
                        <div class="tbody">
                            <p class="name">
                                <span>大角</span>
                                <span>小角</span>
                            </p>
                            <div class="main">
                                <p>
                                    <span>{{data.analy.conner_rate_left}}%</span>
                                    <span>{{data.analy.conner_rate_right}}%</span>
                                </p>
                                <p class="diffodds">{{data.analy.conner_rate_diff}}</p>
                                <p class="diffres" :class="{'resultRed': data.analy.conner_predict_status == '1'}">{{data.analy.conner_predict}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { isLogin, doLogin, isJHAppios, isJHApp } from "../../../utils/base";
export default {
    name: 'diffItem',
    props: ['data', 'isDark'],
    methods: {
        // 处理大小球文案
        dealDxData (str) {
            if (str === '大球') {
                return '大'
            } else if (str === '小球') {
                return '小'
            } else {
                return str
            }
        },
        // 处理胜平负的命中显示颜色
        dealWdlResultColor () {
            if (parseInt(this.data.analy.wdl_predict_status) === 1) {
                const arr = this.data.analy.wdl_predict.split(" ");
                if (arr.length === 1) {
                    return "<span style='color:#F6502F'>" + this.data.analy.wdl_predict + "</span>"
                } else {
                    let str = "";
                    let node = "";
                    if (parseInt(this.baseInfo.home_team_normal_time_score) > parseInt(this.baseInfo.away_team_normal_time_score)) {
                        str = "胜"
                    }
                    if (parseInt(this.baseInfo.home_team_normal_time_score) === parseInt(this.baseInfo.away_team_normal_time_score)) {
                        str = "平"
                    }
                    if (parseInt(this.baseInfo.home_team_normal_time_score) < parseInt(this.baseInfo.away_team_normal_time_score)) {
                        str = "负"
                    }
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i] === str) {
                            if (i === 0) {
                                node += "<span style='color:#F6502F;margin-right:3px'>" + arr[i] + "</span>"
                            } else {
                                node += "<span style='color:#F6502F;margin-left:3px'>" + arr[i] + "</span>"
                            }
                        } else {
                            node += "<span>" + arr[i] + "</span>"
                        }
                    }
                    return node
                }
            } else {
                return "<span>" + this.data.analy.wdl_predict + "</span>"
            }
        },
        gobuy () {
            if (!isLogin) {
                doLogin();
                return
            }
            let url = ""
            if (isJHAppios() || !isJHApp()) {
                url = process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=pay_data&type=' + this.data.info.data_type;
            } else {
                url = process.env.VUE_APP_DOMAIN + '/user/payment?type=' + this.data.info.data_type;
            }
            this.$emit('gobuy', url)
        },
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        }
    }
}
</script>

<style lang="less" scoped>
.diffItem{
    .noData{
        .predict{
            p{
                display: flex;
                justify-content: flex-end;
                font-size: 12px;
                color: #333;
                margin-bottom: 3px;
                span{
                    display: line-block;
                    width: 35px;
                    height: 16px;
                    background: #FF5048;
                    border-radius: 2px;
                    line-height: 16px;
                    color: #fff;
                    margin-left: 5px;
                    text-align: center;
                }
            }
        }
    }
    .haveData{
        text-align: center;
        .diffTable{
            border-radius: 5px;
            overflow: hidden;
            border: 1px solid #eeeeee;
            margin-top: 13px;
            &:first-child{
                margin-top: 0;
            }
            .header{
                width: 100%;
                height: 28px;
                background-color: rgba(22, 154, 255, .1);
                font-size: 12px;
                color: #169AFF;
                line-height: 28px;
            }
            .table{
                width: 100%;
                .name{
                    width: 35px;
                    border-left: 0;
                    span{
                        display: block;
                        line-height: 25px;
                        border-bottom: 1px solid #eeeeee;
                        &:last-child{
                            border-bottom: 0;
                        }
                    }
                }
                .main{
                    width: calc(100% - 35px);
                    display: flex;
                    justify-content: space-between;
                    p{
                        width: 33.33%;
                        border-left: 1px solid #eeeeee;
                        line-height: 50px;
                        span{
                            display: block;
                            line-height: 25px;
                            border-bottom: 1px solid #eeeeee;
                            &:last-child{
                                border-bottom: 0;
                            }
                        }
                    }
                }
                .thead{
                    display: flex;
                    justify-content: space-between;
                    height: 24px;
                    font-size: 11px;
                    color: #169AFF;
                    p{
                        line-height: 24px;
                    }
                }
                .tbody{
                    border-top: 1px solid #eeeeee;
                    display: flex;
                    justify-content: space-between;
                    width: 100%;
                    .diffodds{
                        background-color: #FFEDEC;
                    }
                    .diffres{
                        background-color: #EEEEEE;
                    }
                }
            }
        }
        .resultRed{
            color: #F6502F !important;
        }
        .wdl{
            .table{
                .wdlres{
                    width: 50px;
                    border-left: 1px solid #eeeeee;
                }
                .main{
                    width: calc(100% - 85px);
                    p{
                        width: 25%;
                    }
                }
                .tbody{
                    .wdlres{
                        line-height: 75px;
                        background-color: #F5F5F5;
                    }
                    .diffVal{
                        background-color: #F5F5F5;
                    }
                }
            }
        }
    }
}
.diffItemDark{
    .noData .predict p{
        color: #d3d3d3;
    }
    .haveData{
        background-color: #232323 !important;
        color: #d3d3d3;
        .diffTable{
            border-color: #2f2f2f !important;
            .table{
                .name span{
                    border-color: #2f2f2f !important;;
                }
                .main{
                    p{
                        border-color: #2f2f2f !important;
                        span{
                            border-color: #2f2f2f !important;
                        }
                    }
                }
                .tbody{
                    border-color: #2f2f2f !important;
                    .diffodds{
                        background-color: #232323;
                    }
                    .diffres{
                        background-color: #2f2f2f;
                    }
                }
            }
        }
        .wdl{
            .table{
                .wdlres{
                    border-color: #2f2f2f !important;;
                }
                .tbody{
                    .wdlres,.diffVal{
                        background-color: #191919 !important;;
                    }
                }
            }
        }
    }
}
</style>
